'use client';

import React, { useState } from 'react';
import ProductFiltersBar from './ProductFiltersBar';
import ProductTable from './ProductTable';
import BulkActionBar from './BulkActionBar';
import AddProductDrawer from './AddProductDrawer';
import { Plus, Download, Upload, Package } from 'lucide-react';

export default function ProductManagementContent() {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({
    search: '',
    category: '',
    brand: '',
    status: '',
    stockLevel: '',
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const handleSelectAll = (ids: string[]) => setSelectedIds(ids);
  const handleSelectOne = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };
  const handleBulkClear = () => setSelectedIds([]);

  return (
    <div className="space-y-5">
      {/* Page header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-foreground flex items-center gap-2">
            <Package size={22} className="text-primary" />
            Product Management
          </h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Ahmed Electronics — 347 active products
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button className="btn-ghost text-xs">
            <Upload size={14} />
            Import CSV
          </button>
          <button className="btn-ghost text-xs">
            <Download size={14} />
            Export
          </button>
          <button
            onClick={() => setDrawerOpen(true)}
            className="btn-primary text-xs"
          >
            <Plus size={15} />
            Add Product
          </button>
        </div>
      </div>

      {/* Filters */}
      <ProductFiltersBar filters={filters} onChange={setFilters} />

      {/* Bulk action bar (slides up when rows selected) */}
      <BulkActionBar
        selectedCount={selectedIds.length}
        onClear={handleBulkClear}
      />

      {/* Table */}
      <ProductTable
        filters={filters}
        selectedIds={selectedIds}
        onSelectAll={handleSelectAll}
        onSelectOne={handleSelectOne}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
      />

      {/* Add product drawer */}
      <AddProductDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </div>
  );
}